<!-- 需求设计申请 -->
<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		AllowApplyForVerify
	} from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				flowId:null,
				formLoading: false,
				listLoading: false
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getEmployeeRelation(this.logInfo.EmpNo);
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
			
			clickChoose: async function(dataVal, name) {
				var that=this;
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var title=that.logInfo.fullName;
						var user = res.result.userList[0];
						dataVal.Values = [];
						if(title.indexOf("住宅行政支持组")>-1){
							await that.getEmployeeRelation(user.id);
							that.templateData.TemplateContent.Controls.forEach(item=>{
								if (item.Property.Title[0].Text == "请选择店董") {
									item.Values=[];
									item.Values= that.getRelationList(that.relationList,7);

									
									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(["SC24000029", "钟志斌"]);
									}
								}
							});
						}
						dataVal.Values.unshift([user.id, user.name]);
						dataVal.Value = user.name;
					}
				})
			},
			getTemplate:async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					
					controls.TemplateContent.Controls.forEach(async (item) => {
						var departs = this.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "逐级审批") {
							item.IsShow = false;
							item.Values = [];
							if (departs.indexOf("住宅行政支持组") > -1) {
								item.IsShow = true;
								item.Property.Title[0].Text = "请选择店董"
							}
							if (departs.indexOf("住宅部") > -1) {
								item.Values = this.getRelationList(this.relationList, 8,'住宅部');
							}
							if (departs.indexOf("房友圈") > -1) {
								item.Values = this.getRelationList(this.relationList, 8,'华西区');
							}
							if(departs.indexOf("非营业部") > -1){
								for(var i=0;i<this.relationList.length;i++){
									var childItem=this.relationList[i];
									if(childItem.DeptName == "非营业部"){
										break;
									}
									if(childItem.Items == null){
										continue;
									}
									if(childItem.Items[0].PositionName.indexOf("总监") > -1
									|| childItem.Items[0].PositionName.indexOf("总经理") > -1){
									   // console.log("1111"+childItem.Items[0]);
										item.Values.push([childItem.Items[0].EmpNo,childItem.Items[0].EmpName]);
									}
								}
								

							}
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(["SC24000029", "钟志斌"]);
							}
							
						}
						if (item.Property.Title[0].Text == "部门") {
							var departs = title.split("/");
							item.Value = "房友圈" + departs[departs.indexOf("房友圈") + 1] + "/" + this.logInfo.DeptName;
						}

						if (item.Property.Title[0].Text == "请选择店董") {
							item.Values=[];
							item.Values= this.getRelationList(this.relationList,7);
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(["SC24000029", "钟志斌"]);
							}
							
						}
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.listLoading = false;
				});
			},
			getEmployeeRelation: async function(empNo) {
				await getRelation(empNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请部门："+control.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "使用日期"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"使用日期："+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "物料形式"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var NameOfData = "";
				for (var i = 0; i < control2.Config.Selector.Options.length; i++) {
					var data = control2.Config.Selector.Options[i];
					if(data.Key ==control2.Value){
						NameOfData = data.Value[0].Text;
					}
				}
				info.SummaryInfo.push({"Text":"物料形式："+NameOfData,"Lang":"zh_CN"});
				SummaryList.push(info);
				this.templateData.SummaryList=SummaryList;
				
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
				}
				isSubmit = true;
				this.listLoading = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		},
		watch: {
			relationList(val, oldVal) {
				if (oldVal == null) {
					this.getTemplate();
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
